import React, { useEffect, useState } from 'react';
import { Footer } from '../../components/footer';
import { Link, useNavigate } from 'react-router-dom';
import { useToast } from '../../hook/usetoast';
import { useGetAirDropTimer } from '../home/api/api';
import { copyToClipboard } from '../../lib/copytoClipboard';
import { useUserLoginHistory } from './api/dashboardApi';
import moment from 'moment';
import { Pagination, PaginationItem, PaginationLink } from 'reactstrap';
import { useModalContext } from '../../contexts/ModalContext';
import { useEliteClub, useStakeDetails } from './stakingwallet/api';
import TopUpLevelsModal from '../modals/topupLevels';
import { useProfileDetails } from '../profile-details/api/profileapi';
import profileImage from '../../assets/images/useruploadImg.png'
import { Check } from 'lucide-react';
import SocialMedia from '../modals/SocialMedia';

const Dashboard = () => {
    const toast = useToast()
    const { userDetails, setUserDetails, isBuyToken, topUpLevelsModal, setTopUpLevelsModal } = useModalContext()
    const { data: userProfile } = useProfileDetails()
    const [claimSuccessModal, setClaimSuccessModal] = useState(false);

    const { data: stakeBalance } = useStakeDetails()
    const overAllStake = stakeBalance?.data?.stakeWalletAvailable + stakeBalance?.data?.activeStake

    const { data: eliteClub } = useEliteClub()

    const navigate = useNavigate()
    const userData = useGetAirDropTimer()

    useEffect(() => {
        getProfile()

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [sessionStorage.getItem('user_JWT'), isBuyToken])

    const getProfile = async () => {
        if (sessionStorage.getItem('user_JWT')) {
            const res = await userData.mutateAsync()
            setUserDetails(res)
        }
    }
    const walletCardList = [
        {
            icon: require('../../assets/images/dashboard/walletIcon01.svg'),
            name: 'Master Wallet',
            coinImg: require('../../assets/images/dashboard/tether-20.png'),
            value: userDetails?.data?.masterWallet ? parseFloat(userDetails?.data?.masterWallet).toFixed(4) : 0,
            token: 'USDT',
            link: 'master-wallet'
        },
        {
            icon: require('../../assets/images/dashboard/walletIcon02.svg'),
            name: 'Upgrade Wallet',
            coinImg: require('../../assets/images/dashboard/tether-20.png'),
            value: userDetails?.data?.topupWallet ? parseFloat(userDetails?.data?.topupWallet).toFixed(4) : 0,
            token: 'USDT',
            link: 'upgrade-wallet'
        },
        {
            icon: require('../../assets/images/dashboard/walletIcon03.svg'),
            name: 'Over All Stake Wallet',
            coinImg: require('../../assets/images/dashboard/thepill20.png'),
            value: (overAllStake)?.toString().includes('.') ? parseFloat(overAllStake)?.toFixed(5).replace(/(\.0+)?$/, '') : overAllStake,
            token: 'TPL',
            link: 'staking-wallet'
        },
        {
            icon: require('../../assets/images/dashboard/walletIcon04.svg'),
            name: 'Redeem Wallet ',
            coinImg: require('../../assets/images/dashboard/thepill20.png'),
            value: (stakeBalance?.data?.redeemWalletAvailable)?.toString().includes('.') ? parseFloat(stakeBalance?.data?.redeemWalletAvailable)?.toFixed(5).replace(/(\.0+)?$/, '') : stakeBalance?.data?.redeemWalletAvailable,
            token: 'TPL',
            link: 'redeem-wallet'
        }
    ]
    const [uniqueId, setUniqueId] = useState(false)


    const copyuserAddress = async data => {
        setUniqueId(data)
        await copyToClipboard(`https://thepillcoin.com/${data}`)
        toast.success("Referral Link is copied")
        setTimeout(() => {
            setUniqueId(false)
        }, 300);
    }



    const copyUserId = async data => {
        setUniqueId(data)
        await copyToClipboard(data)
        toast.success("ID is copied")
        setTimeout(() => {
            setUniqueId(false)
        }, 300);
    }
    const [page, setPage] = useState(0);
    const rowsPerPage = 10;
    const { data: userHistory } = useUserLoginHistory({
        page,
        size: rowsPerPage,
    })
    const totalPages = Math.ceil(userHistory?.count / rowsPerPage);


    const handlePageChange = (newPage) => {

        const currentScrollY = window.scrollY;

        if (newPage >= 0 && newPage < totalPages) {
            setPage(newPage);
            window.requestAnimationFrame(() => {
                window.scrollTo(0, currentScrollY);
            });
        }
    };
    const topUpModel = async () => {
        if (userProfile?.completedLevels === 19) {
            toast.success("Top Level Completed")
        } else {
            setTopUpLevelsModal(!topUpLevelsModal)
        }
    }
    let content;

    if (userDetails?.data?.refferCode) {
        if (uniqueId === userDetails?.data?.refferCode) {
            content = <Check size={20} color="#FCD535" cursor="not-allowed" />;
        } else {
            content = (
                <button className='btn btnEmpty' onClick={() => copyuserAddress(userDetails.data.refferCode)}>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M7 9.667C7 8.95967 7.28099 8.28131 7.78115 7.78115C8.28131 7.28099 8.95967 7 9.667 7H18.333C18.6832 7 19.03 7.06898 19.3536 7.20301C19.6772 7.33704 19.9712 7.53349 20.2189 7.78115C20.4665 8.0288 20.663 8.32281 20.797 8.64638C20.931 8.96996 21 9.31676 21 9.667V18.333C21 18.6832 20.931 19.03 20.797 19.3536C20.663 19.6772 20.4665 19.9712 20.2189 20.2189C19.9712 20.4665 19.6772 20.663 19.3536 20.797C19.03 20.931 18.6832 21 18.333 21H9.667C9.31676 21 8.96996 20.931 8.64638 20.797C8.32281 20.663 8.0288 20.4665 7.78115 20.2189C7.53349 19.9712 7.33704 19.6772 7.20301 19.3536C7.06898 19.03 7 18.6832 7 18.333V9.667Z" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M4.012 16.737C3.70534 16.5622 3.45027 16.3095 3.27258 16.0045C3.09488 15.6995 3.00085 15.353 3 15V5C3 3.9 3.9 3 5 3H15C15.75 3 16.158 3.385 16.5 4" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                </button>
            );
        }
    }
    let userIDCopy;
    if (userDetails?.data?.userId) {
        if (uniqueId === userDetails?.data?.userId) {
            userIDCopy = <Check size={20} color="#FCD535" cursor="not-allowed" />
        } else {
            userIDCopy = (
                <button className='btn btnEmpty' onClick={() => copyUserId(userDetails?.data?.userId)}>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M7 9.667C7 8.95967 7.28099 8.28131 7.78115 7.78115C8.28131 7.28099 8.95967 7 9.667 7H18.333C18.6832 7 19.03 7.06898 19.3536 7.20301C19.6772 7.33704 19.9712 7.53349 20.2189 7.78115C20.4665 8.0288 20.663 8.32281 20.797 8.64638C20.931 8.96996 21 9.31676 21 9.667V18.333C21 18.6832 20.931 19.03 20.797 19.3536C20.663 19.6772 20.4665 19.9712 20.2189 20.2189C19.9712 20.4665 19.6772 20.663 19.3536 20.797C19.03 20.931 18.6832 21 18.333 21H9.667C9.31676 21 8.96996 20.931 8.64638 20.797C8.32281 20.663 8.0288 20.4665 7.78115 20.2189C7.53349 19.9712 7.33704 19.6772 7.20301 19.3536C7.06898 19.03 7 18.6832 7 18.333V9.667Z" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M4.012 16.737C3.70534 16.5622 3.45027 16.3095 3.27258 16.0045C3.09488 15.6995 3.00085 15.353 3 15V5C3 3.9 3.9 3 5 3H15C15.75 3 16.158 3.385 16.5 4" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                </button>
            )
        }
    }

    return (
        <>
            <div className="mainContent">
                <div className="pageContent def-py-30">
                    <div className='container'>
                        <div className="appPagetitle">Dashboard</div>
                        <div className='row'>
                            <div className="col-lg-12">
                                <div className="appcard mb-4">
                                    <div className="cardHeader d-flex justify-content-between flex-wrap">
                                        <div className='bxTitle mb-3 mb-sm-0'>
                                            <img src={require('../../assets/images/dashboard/walletImg.svg').default} alt='walletImg.svg' />
                                            <span>Wallet</span>
                                        </div>
                                        <div className='d-flex g-15 align-items-center flex-wrap'>
                                            <span className='dashboardLabelbx'>Airdrop <img src={require('../../assets/images/coin45.png')} alt='coin45.png' className='img-w26' /> <span className="text-white">{userDetails?.data?.airdropRewardAmount} TPL</span></span>
                                            <button className='btn btn-primary px-4' onClick={topUpModel}>Top-Up Level</button>
                                        </div>
                                    </div>
                                    <div className="row">
                                        {
                                            walletCardList.map(({ icon, name, coinImg, value, token, link }, i) =>
                                                <div className="col-lg-3 col-md-6" key={value?._id}>
                                                    <div className='appDarkCard walletCard mb-3 mb-lg-0'>
                                                        <Link to={`/${link}`} className='btn btnArrowcard' >
                                                            <svg width="12" height="10" viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path d="M8.58881 3.53662L1.28975 9.35339" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
                                                                <path d="M7.95354 9.15769L8.58881 3.53662" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
                                                                <path d="M2.96778 2.90159L8.58885 3.53686" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
                                                            </svg>
                                                        </Link>
                                                        <div className='wc-img mb-3'>
                                                            <span className='wcImg-circle animate__animated animate__pulse animate__infinite'>
                                                                <img src={icon.default} alt='iconwc' className='animate__animated animate__pulse animate__infinite' />
                                                            </span>
                                                        </div>
                                                        <div className='wc-name'>{name}</div>
                                                        <div className='wc-value'>
                                                            <img src={coinImg} alt='coinImg' className='img-w20' />
                                                            <span className=''>{value}</span>
                                                            <span className='smTxt'>{token}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        }
                                    </div>
                                </div>
                                <div className="appcard mb-4">
                                    <div className="cardHeader d-flex justify-content-between flex-wrap">
                                        <div className='bxTitle mb-3 mb-md-0'>
                                            <img src={require('../../assets/images/dashboard/profileImg.svg').default} alt='walletImg.svg' />
                                            <span>Profile</span>
                                        </div>
                                        <div className='d-flex g-15 align-items-center'>
                                            <span className='dashboardLabelbx'>Referred By <span className="text-white">{userDetails?.data?.refferdByUserId ? userDetails?.data?.refferdByUserId : "---"}</span></span>
                                            <span className='dashboardLabelbx'>ELITE CLUB <span className={eliteClub?.status ? 'text-lightgreen' : 'text-lightred'}>{eliteClub?.status ? 'Achieved' : 'Not Achieved'}</span></span>
                                            <button className='btn btn-secondary px-4' onClick={() => navigate('/profile-details')}>Update Profile</button>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-lg-4 mb-4 mb-lg-0">
                                            <div className="d-flex align-items-center g-15">
                                                <div className='userImgUpload'>
                                                    <div className='userImgBorder'>
                                                        <img src={userDetails?.data?.profileImage || profileImage} alt='userImg' className='img-fluid' />
                                                    </div>
                                                </div>
                                                <div>
                                                    <div className='pro-name mb-2'>{userDetails?.data?.username ? userDetails?.data?.username : "---"}</div>
                                                    <div className='pro-id'>ID <span className='fw-600 text-white'>{userDetails?.data?.userId ? userDetails?.data?.userId : "---"}

                                                        {userIDCopy}
                                                    </span></div>
                                                </div>
                                            </div>
                                        </div>


                                        <div className="col-lg-3">
                                            <div className='appDarkCard walletCard py-3 mb-4 mb-lg-0'>
                                                <Link to={`/direct-refferals`} className='btn btnArrowcard' >
                                                    <svg width="12" height="10" viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M8.58881 3.53662L1.28975 9.35339" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
                                                        <path d="M7.95354 9.15769L8.58881 3.53662" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
                                                        <path d="M2.96778 2.90159L8.58885 3.53686" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
                                                    </svg>
                                                </Link>
                                                <div className='wc-img mb-1'>
                                                    <span className='wcImg-circle'>
                                                        <img src={require('../../assets/images/dashboard/profilegroup.svg').default} alt='iconwc' />
                                                    </span>
                                                </div>
                                                <div className='wc-name'>Direct Members</div>
                                                <div className='wc-value'>
                                                    <span className=''>{userDetails?.data?.directMembers ? userDetails?.data?.directMembers : 0}</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-5">
                                            <div className='appDarkCard h-100'>
                                                <div className='fs-14 fw-400 text-white-60 mb-2 pt-3'>Referral Link </div>
                                                <div className='copyIdBx'>
                                                    <span>{userDetails?.data?.refferCode ? `https://thepillcoin.com/${userDetails?.data?.refferCode}` : "---"}</span>

                                                    {content}
                                                    {
                                                        userDetails?.data?.refferCode && <button className='btn btnEmpty' onClick={() => setClaimSuccessModal(true)}> <img src={require('../../assets/images/footer/icons8-share.svg').default} alt="" /></button>

                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="appcard mb-4 px-0 pb-2 cardbg">
                                    <div className="cardHeader border-bottom-0 d-flex justify-content-between flex-wrap px-4 pb-0">
                                        <div className='bxTitle'>
                                            <img src={require('../../assets/images/dashboard/login-historyImg.svg').default} alt='walletImg.svg' />
                                            <span>Login History</span>
                                        </div>
                                    </div>
                                    <div className='table-responsive mb-3'>
                                        <table className='table myapptable table-hover table-borderless mb-0'>
                                            <thead>
                                                <tr>
                                                    <th className='pl-4'>Ip Address</th>
                                                    <th>Browser</th>
                                                    <th>Devices</th>
                                                    <th>Date & Time</th>
                                                    <th >Location</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    userHistory?.data && userHistory.data.length > 0 ? (
                                                        userHistory.data.map((v, i) => (
                                                            <tr key={v?._id}>
                                                                <td className='pl-4'>{v?.ip_address}</td>
                                                                <td>{v?.browser_name ? v?.browser_name : "--"}</td>
                                                                <td>{v?.os}</td>
                                                                <td className='pr-4 text-nowrap'>
                                                                    <span>{moment(v.createdAt).format("DD/MM/YYYY | hh:mm A")}</span>
                                                                </td>
                                                                <td className='text-nowrap'>{v?.location} </td>
                                                            </tr>
                                                        ))
                                                    ) : (
                                                        <tr>
                                                            <td colSpan="5" className="text-center">No data found</td>
                                                        </tr>
                                                    )
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                    <div className="px-4">
                                        <div className='row'>

                                            <div className='col-lg-12'>
                                                <Pagination aria-label="Page navigation" className='customPagination'>
                                                    <PaginationItem disabled={page === 0}>
                                                        <PaginationLink previous href="#" onClick={() => handlePageChange(page - 1)} className='prevbtn'>
                                                            <i className='bi bi-arrow-left align-bottom'></i> Previous
                                                        </PaginationLink>
                                                    </PaginationItem>

                                                    <span className='number'>
                                                        {totalPages > 6 && page > 3 && (
                                                            <>
                                                                <PaginationItem key={0} active={page === 0}>
                                                                    <PaginationLink href="#" onClick={() => handlePageChange(0)}>
                                                                        1
                                                                    </PaginationLink>
                                                                </PaginationItem>
                                                                <PaginationItem disabled>
                                                                    <PaginationLink href="#">
                                                                        ...
                                                                    </PaginationLink>
                                                                </PaginationItem>
                                                            </>
                                                        )}

                                                        {/* Show pages near the current page */}
                                                        {Array.from({ length: totalPages }, (_, index) => {
                                                            if (index === 1 || index === 2 || index === totalPages - 0 || (index >= page - 2 && index <= page + 2)) {
                                                                return (
                                                                    <PaginationItem key={index} active={index === page}>
                                                                        <PaginationLink href="#" onClick={() => handlePageChange(index)}>
                                                                            {index + 1}
                                                                        </PaginationLink>
                                                                    </PaginationItem>
                                                                );
                                                            }
                                                            return null;
                                                        })}

                                                        {totalPages > 6 && page < totalPages - 4 && (
                                                            <>
                                                                <PaginationItem disabled>
                                                                    <PaginationLink href="#">
                                                                        ...
                                                                    </PaginationLink>
                                                                </PaginationItem>
                                                                <PaginationItem key={totalPages - 1} active={page === totalPages - 1}>
                                                                    <PaginationLink href="#" onClick={() => handlePageChange(totalPages - 1)}>
                                                                        {totalPages}
                                                                    </PaginationLink>
                                                                </PaginationItem>
                                                            </>
                                                        )}
                                                    </span>

                                                    <PaginationItem disabled={page === totalPages - 1}>
                                                        <PaginationLink next href="#" onClick={() => handlePageChange(page + 1)} className='nextbtn'>
                                                            Next <i className='bi bi-arrow-right align-bottom'></i>
                                                        </PaginationLink>
                                                    </PaginationItem>
                                                </Pagination>
                                            </div>


                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
            <TopUpLevelsModal modalOpen={topUpLevelsModal} modalClose={() => setTopUpLevelsModal(!topUpLevelsModal)} />
            <SocialMedia modalOpen={claimSuccessModal} modalClose={() => setClaimSuccessModal(!claimSuccessModal)} userDetails={userDetails} />

        </>
    )
}

export default Dashboard;